import { Editor } from '@tiptap/core';
import TextAlign from '@tiptap/extension-text-align';
import { TextStyle, FontFamily, FontSize } from '@tiptap/extension-text-style';
import StarterKit from '@tiptap/starter-kit';

const getActiveFontSize = (editor: Editor | null) => {
  const attrs = editor?.getAttributes('textStyle');
  return attrs?.fontSize || '16px';
};


export const initializeEditor = (
  editorRef,
  tiptapInstance,
  body,
  setBody,
  setCurrentFontSize?
) => {
  const editor = new Editor({
    element: editorRef.current,
    extensions: [
      StarterKit,
      TextStyle,
      FontFamily.configure({
        types: ['textStyle'],
      }),
      FontSize,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      })
    ],
    content: body,
    onUpdate: ({ editor }) => {
      setBody(editor.getHTML());
    },
    onTransaction: ({ editor }) => {
      // Update the React state whenever the cursor moves or content changes
      setCurrentFontSize && setCurrentFontSize(() => getActiveFontSize(editor));
    },
  });

  tiptapInstance.current = editor;

  return () => {
    if (tiptapInstance.current) {
      tiptapInstance.current.destroy();
      tiptapInstance.current = null;
    }
  };
};
